/**
 * The signed-in tenant's provider settings.
 *
 * @module hooks/useTenantProviderSettings
 */

import { useOptionalWorkspaceContext } from "@/router/workspace-context";
import type { ProviderSettings } from "@/types/provider";

/** The workspace's tenant settings, `null` outside a workspace or before they load. */
export function useTenantProviderSettings(): ProviderSettings | null {
  return useOptionalWorkspaceContext()?.tenantProviderSettings ?? null;
}
